let moduleVersion = "3.5.7";
export const getCurrentVersion = () => moduleVersion;
export const setCurrentVersion = version => {
  moduleVersion = version;
};
//# sourceMappingURL=version.js.map